// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Tjbj","amount":"Amount_amount__7j8yp","tip":"Amount_tip__19vQo","tipHeader":"Amount_tipHeader__34uVy","tipsWrap":"Amount_tipsWrap__3kmaK"};